// Base64 cho chuỗi UTF-8, thay polyfill `buffer` (~23 KB trong vendor) — kết quả giống Buffer.from(str).toString('base64')

const toBinary = (str: string): string => {
  if (typeof TextEncoder !== 'undefined') {
    const bytes = new TextEncoder().encode(str);
    let binary = '';
    for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
    return binary;
  }
  // Môi trường test cũ (jsdom) chưa có TextEncoder
  return unescape(encodeURIComponent(str));
};

const fromBinary = (binary: string): string => {
  if (typeof TextDecoder !== 'undefined') {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }
  return decodeURIComponent(escape(binary));
};

export const encodeUtf8Base64 = (str: string): string => btoa(toBinary(str));

/** Giải mã base64 → chuỗi UTF-8; chuỗi base64 không hợp lệ trả về '' */
export const decodeUtf8Base64 = (base64: string): string => {
  try {
    return fromBinary(atob(base64));
  } catch (error) {
    return '';
  }
};
